export default "__VITE_ASSET__BzyRItpb__"